module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1p",
    attrs: {
      "id": "p0027-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_20",
      "id": "sn_20"
    }
  }, [_vm._v("DAY 20")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_20"
    }
  }, [_vm._v("“NEVER AGAIN!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("God said to Noah . . . “I now establish my covenant with you and with your descendants after you . . . Never again will all life be destroyed by the waters of a flood” . . .")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', [_c('i', [_vm._v("And God said . . . “I have set my rainbow in the clouds, and it will be the sign of the covenant.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 9:8–13, 15")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0027-04-5"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("inky promise!” “Cross my heart!” Somehow just saying, “I promise” doesn’t seem sufficient. As if there were a gray area when it comes to keeping a promise. But there is no gray area: a promise is kept, or it’s not. And God always keeps his promises. Always.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Consider the promise God made in Genesis 9. The once angry, heartbroken God had exercised his judgment and sent a flood that covered the earth. After the waters receded, God made this promise: “Never again will all life be destroyed by the waters of a flood.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Almighty didn’t need to do anything to reinforce the validity of his eternal promise—but he chose to: “I have set my rainbow in the clouds, and it will be the sign of the covenant between me and the earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The physical beauty of a rainbow spanning the sky is just part of the story. The more important part is the spiritual beauty of God’s faithfulness to us, his unfaithful people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_vm._v("GOD PROMISES UNFAITHFUL PEOPLE HIS UNENDING FAITHFULNESS.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39f3068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter23.vue
// module id = 129
// module chunks = 0